import React, {useEffect, useState} from "react";
import {Button, Input, Modal, notification, Table} from "antd";
import Spinner from "../../spinner";
import { getWithTranslate } from "../../../helpers/doc_type.helper";
import {companyService, consignorService, legalEntityService} from "../../../services";
import i18n from "../../../i18n";

const { TextArea } = Input;

export default function ModalApproveGosLog({isShow, setIsShow, company}) {
    const legalEntityDataAliases = getWithTranslate('legalEntityForGosLogAliases');
    const [loading, setLoading] = useState(true);
    const [declineComment, setDeclineComment] = useState('');
    const [showCommentInput, setShowCommentInput] = useState(false);

    const [legalEntityInfo, setLegalEntityInfo] = useState([]);

    const handleChangeGosLog = (status, docFields = null, comment = '') => {
        legalEntityService.changeLegalEntityGosLog(company.legalEntityID, status, docFields, comment)
        .then((response) => {
            if (response.code === 400) {
                notification.error({
                    message: i18n.t('Обновление статуса регистрации в Гос.Лог'),
                    description: response.message,
                });
            } else {
                if (response.status === 'success') {
                    notification.success({
                    message: i18n.t('Обновление статуса регистрации в Гос.Лог'),
                    description: response.message,
                    });
                    setIsShow(false);
                }
            }
        })
        .catch((err) => {
            notification.error({
            message: i18n.t('Обновление статуса регистрации в Гос.Лог'), description: err,
            });
        })
        .finally(() => {
        })
    }

    const [columns, setColumns] = useState([
        {
            title: '',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: '',
            key: 'data',
            render: (record) => {
                function isUrl(string) {
                    let regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
                    return regexp.test(string);
                }

                if (isUrl(record.data)) {
                    return (
                        <React.Fragment>
                            <a href={record.data} target="_blank" rel="noopener noreferrer" className="active">{i18n.t('main.buttons.open')}</a>
                        </React.Fragment>
                    );
                } else {
                    if (record.data === 0 || record.data === 1) {
                        return record.data ? i18n.t('main.yes') : i18n.t('main.no');
                    }
                    return record.data
                }
            }
        },
    ]);

    useEffect(() => {
        if (isShow && company) {
            setLoading(true);
            companyService.getLegalEntityFullInfo(company.legalEntityID)
                .then(response => {
                    let data = [];
                    Object.keys(response).forEach((element) => {
                        if (response[element] !== null && response[element] !== '') {
                            if (typeof legalEntityDataAliases[element] !== 'undefined')
                            data.push(
                                {
                                    name: legalEntityDataAliases[element],
                                    data: response[element]
                                }
                            );
                        }
                    });

                    Object.keys(response.Docs).forEach((element) => {
                        if (response.Docs[element] !== null) {
                            let document = response.Docs[element];
                            if (typeof legalEntityDataAliases[document.Name] !== 'undefined') {
                                data.push(
                                    {
                                        name: legalEntityDataAliases[document.Name],
                                        data: document.Url
                                    }
                                );
                            }
                        }
                    });

                    setLegalEntityInfo(data);
                    setLoading(false);
                })
                .catch(err => {
                    notification.error({
                        message: i18n.t('components.notification.titles.getLegalEntityDocs'),
                        description: err,
                    });
                    setLoading(false);
                });
        }
    }, [isShow, company]);

    const handleApprove = () => {
        handleChangeGosLog(4);
    };

    const handleDecline = () => {
        if (showCommentInput) {
            handleChangeGosLog(5, null, declineComment);
        } else {
            setShowCommentInput(true);
        }
    };

    return (
        <Modal
            title="Согласование Гос.Лог"
            cancelText={i18n.t('main.buttons.close')}
            className="modal-window"
            align={null}
            visible={isShow}
            onCancel={() => {
                setIsShow(false);
                setDeclineComment('');
                setShowCommentInput(false);
            }}
            footer={
                <>
                    <Button
                        key="approve"
                        type="primary"
                        style={{background: "#1CAA53", borderColor: "transparent", marginRight: "10px"}}
                        onClick={handleApprove}
                    >
                        Утвердить
                    </Button>
                    <Button
                        key="decline"
                        type="danger"
                        danger
                        onClick={handleDecline}
                    >
                        Отклонить
                    </Button>
                </>
            }
        >
            <Spinner loading={loading} tip={i18n.t('main.loadText.loading')}>
                <Table
                    columns={columns}
                    dataSource={legalEntityInfo}
                    rowKey="name"
                    pagination={false}
                    size="small"
                    showHeader={false}
                />
                {showCommentInput && (
                    <div style={{marginTop: '20px'}}>
                        <TextArea
                            rows={4}
                            placeholder="Введите комментарий причины отклонения"
                            value={declineComment}
                            onChange={(e) => setDeclineComment(e.target.value)}
                        />
                    </div>
                )}
            </Spinner>
        </Modal>
    );
}